// extracted by mini-css-extract-plugin
module.exports = {"calldialpadtoast":"toastdialpad_calldialpadtoast__8Ks0P","toast":"toastdialpad_toast__2l1jh","close":"toastdialpad_close__3XXt-"};